﻿import GoogleAnalyticsEvent from "dataTransferObjects/googleAnalyticsEvent";
import CommunityInformationLead from "./communityInformationLead";

/* This class represents a lead of type More Information for a basic community. */
export default class CommunityInformationLeadBasic extends CommunityInformationLead {
    constructor(formData) {
      super(formData);
      this.type = 'postCommunityBrochureBasic';
      this.xxTrustedFormCertUrl = formData.xxTrustedFormCertUrl;
    }

    static getLeadSubmitedAnalyticsData() {
      return new GoogleAnalyticsEvent("TDV Events", "Direct Leads", "Search-CTA-Learn-More")
    }
  }
  